var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUsersLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M7.416 1.792a3.125 3.125 0 1 0 0 6.25 3.125 3.125 0 0 0 0-6.25ZM3.041 4.917a4.375 4.375 0 1 1 8.75 0 4.375 4.375 0 0 1-8.75 0ZM12.625 3.667c0-.345.28-.625.625-.625a3.542 3.542 0 0 1 0 7.083.625.625 0 1 1 0-1.25 2.292 2.292 0 1 0 0-4.583.625.625 0 0 1-.625-.625ZM3.213 12.374c-.948.609-1.422 1.375-1.422 2.126 0 .75.474 1.517 1.422 2.126.94.605 2.277.999 3.786.999 1.51 0 2.847-.394 3.787-1 .947-.608 1.422-1.374 1.422-2.125 0-.75-.475-1.517-1.422-2.126-.94-.605-2.278-.999-3.787-.999s-2.846.394-3.786 1Zm-.676-1.051c1.17-.753 2.75-1.198 4.462-1.198 1.713 0 3.292.445 4.463 1.198 1.164.748 1.996 1.857 1.996 3.177s-.832 2.43-1.996 3.177c-1.17.753-2.75 1.198-4.463 1.198-1.712 0-3.292-.445-4.462-1.198C1.373 16.93.54 15.82.54 14.5s.832-2.43 1.996-3.177ZM14.312 11.27a.625.625 0 0 1 .766-.442c.93.249 1.754.656 2.358 1.195.605.54 1.022 1.245 1.022 2.061 0 .816-.417 1.521-1.022 2.061-.604.539-1.428.946-2.358 1.195a.625.625 0 1 1-.323-1.207c.79-.212 1.425-.543 1.849-.92.423-.378.604-.768.604-1.129s-.181-.752-.604-1.128c-.424-.378-1.058-.709-1.85-.92a.625.625 0 0 1-.442-.766Z",
    clipRule: "evenodd"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsersLight);
export default __webpack_public_path__ + "static/media/users-light.12428c1013316bef3d3284b19f4397e5.svg";
export { ForwardRef as ReactComponent };